( function( app ) {
  const COMPONENT = {
    init: function() {},
    finalize: function() {},
  };

  app.registerComponent( 'double-feature-content', COMPONENT );
} )( app );
